import { Component, OnInit, OnDestroy } from '@angular/core';
import {
  fromEvent as observableFromEvent,
  Observable,
  Subscription
} from 'rxjs';

@Component({
  selector: 'app-online-status',
  templateUrl: './online-status.component.html',
  styleUrls: ['./online-status.component.css']
})
export class OnlineStatusComponent implements OnInit, OnDestroy {
  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];

  connectionStatusMessage: string;
  onlineStatus = true;
  ngOnInit(): void {
    //  Get the online/offline status from browser window
    this.onlineEvent = observableFromEvent(window, 'online');
    this.offlineEvent = observableFromEvent(window, 'offline');

    this.subscriptions.push(
      this.onlineEvent.subscribe(e => {
        this.connectionStatusMessage = 'Back to online';
        this.onlineStatus = true;
        console.log('Online...', this.subscriptions);
      })
    );

    this.subscriptions.push(
      this.offlineEvent.subscribe(e => {
        this.connectionStatusMessage = 'Please Check Your Connection 🌐';
        this.onlineStatus = false;
        console.log('Offline...', this.subscriptions);
      })
    );
  }

  ngOnDestroy(): void {
    // Unsubscribe all subscriptions to avoid memory leak
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
